var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LinkedIn_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LinkedIn_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 0H.75C.3 0 0 .3 0 .75v16.5c0 .45.3.75.75.75h16.5c.45 0 .75-.3.75-.75V.75c0-.45-.3-.75-.75-.75ZM5.325 15.375H2.7V6.75h2.7v8.625h-.075ZM3.975 5.55A1.584 1.584 0 0 1 2.4 3.975c0-.825.675-1.575 1.575-1.575.825 0 1.575.675 1.575 1.575 0 .9-.675 1.575-1.575 1.575Zm11.4 9.825h-2.7v-4.2c0-.975 0-2.25-1.35-2.25-1.425 0-1.575 1.05-1.575 2.175v4.275h-2.7V6.75H9.6v1.2c.375-.675 1.2-1.35 2.55-1.35 2.7 0 3.225 1.8 3.225 4.125v4.65Z",
    fill: "#444"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LinkedIn_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#17181D",
    stroke: "#17181D",
    d: "M0 0h18v18H0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LinkedIn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export { SvgLinkedIn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzUwMDZfNDMzKSI+CjxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0id2hpdGUiLz4KPG1hc2sgaWQ9Im1hc2swXzUwMDZfNDMzIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPgo8cGF0aCBkPSJNMTcuMjUgMEgwLjc1QzAuMyAwIDAgMC4zIDAgMC43NVYxNy4yNUMwIDE3LjcgMC4zIDE4IDAuNzUgMThIMTcuMjVDMTcuNyAxOCAxOCAxNy43IDE4IDE3LjI1VjAuNzVDMTggMC4zIDE3LjcgMCAxNy4yNSAwWk01LjMyNSAxNS4zNzVIMi43VjYuNzVINS40VjE1LjM3NUg1LjMyNVpNMy45NzUgNS41NUMzLjE1IDUuNTUgMi40IDQuODc1IDIuNCAzLjk3NUMyLjQgMy4xNSAzLjA3NSAyLjQgMy45NzUgMi40QzQuOCAyLjQgNS41NSAzLjA3NSA1LjU1IDMuOTc1QzUuNTUgNC44NzUgNC44NzUgNS41NSAzLjk3NSA1LjU1Wk0xNS4zNzUgMTUuMzc1SDEyLjY3NVYxMS4xNzVDMTIuNjc1IDEwLjIgMTIuNjc1IDguOTI1IDExLjMyNSA4LjkyNUM5LjkgOC45MjUgOS43NSA5Ljk3NSA5Ljc1IDExLjFWMTUuMzc1SDcuMDVWNi43NUg5LjZWNy45NUM5Ljk3NSA3LjI3NSAxMC44IDYuNiAxMi4xNSA2LjZDMTQuODUgNi42IDE1LjM3NSA4LjQgMTUuMzc1IDEwLjcyNVYxNS4zNzVaIiBmaWxsPSIjNDQ0NDQ0Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF81MDA2XzQzMykiPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9IiMxNzE4MUQiIHN0cm9rZT0iIzE3MTgxRCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNTAwNl80MzMiPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";